// A small, quiet "Threat" readout under the left-hand buttons: the danger level your wealth has earned, and the raid
// size it brings. Purely informational (it explains WHY raids are the size they are).
import { Events, on } from './eventBus.js'
import { dangerTier } from '../game/raidDirector.js'
import { getWealth } from '../game/seasonManager.js'
import { formatCoins } from './format.js'

export function mountThreatChip() {
  const el = document.createElement('div')
  el.className = 'threat-chip'
  document.body.appendChild(el)
  const refresh = () => {
    const t = dangerTier()
    el.innerHTML = `<span class="threat-chip__ico">⚔</span> Threat: <b>${t.name}</b> <i>raids of ${t.size[0]}–${t.size[1]}</i>`
    el.title = `Raids grow with the wealth you hold (you have ${formatCoins(getWealth())}). Each new level starts at ${formatCoins(t.minWealth)}.`
  }
  on(Events.WealthChange, refresh)
  on(Events.KingdomChange, refresh)
  setInterval(refresh, 5000)
  refresh()
}
